var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        this.shouldShowCustomLogo ? "" : _vm.$style.short,
        _vm.$style.formContainer,
      ],
    },
    [
      _c(
        "LoginCard",
        {
          attrs: {
            header: _vm.headerTitle,
            showCustomLogo: _vm.shouldShowCustomLogo,
          },
        },
        [
          _c("p", { class: _vm.$style.subheader }, [
            _vm._v(
              "\n      " + _vm._s(_vm.mfaDisplayText.subheaderText) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _c("Alert", {
            model: {
              value: _vm.errorMessage,
              callback: function ($$v) {
                _vm.errorMessage = $$v
              },
              expression: "errorMessage",
            },
          }),
          _vm._v(" "),
          _c("LoginInputConfirmation", {
            attrs: {
              isLoading: _vm.isLoading,
              placeholder: "Enter Code",
              token: _vm.token,
              buttonText: _vm.mfaDisplayText.buttonText,
              shouldShowTOTPResetLink: _vm.shouldShowTOTPResetLink,
            },
            on: {
              input: function ($event) {
                _vm.token = $event
              },
              onSubmit: _vm.submit,
              onRequestReset: _vm.requestResetTOTP,
            },
          }),
          _vm._v(" "),
          _vm.shouldShowMfaChooser
            ? _c(
                "ChooseMfa",
                _vm._b(
                  { attrs: { selectedFactor: _vm.factor } },
                  "ChooseMfa",
                  _vm.$props,
                  false
                )
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.shouldShowMfaChooser ? _c("LogoIcon") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }